import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { CatalogNode } from '../models/CatalogNode';

export interface GetFavoriteItemsInput {
  application: string;
  size?: number;
}

export interface GetFavoriteItemsOutput {
  hits?: number;
  return?: CatalogNode[];
}

export async function getFavoriteItems(input: GetFavoriteItemsInput): Promise<FetchResponse<GetFavoriteItemsOutput>> {
  return await portalCustomAPI.fetch<GetFavoriteItemsInput, GetFavoriteItemsOutput>('getFavoriteItems', input);
}
